import Location from './component';

export default Location;
